import {ApiRes} from '../../types/api'
import {API_URL, apiGetV1} from '../api'

export interface ILeaderGraph {
    when: number
    profit: number
    earning: number
    start_balance: number
    end_balance: number
    deposit: number
    withdraw: number
    twr: number
    mwr: number
}

export const getLeaderGraph = async (id: string): Promise<ApiRes<ILeaderGraph[]>> => {
    return await apiGetV1(API_URL, `admin/leader/graph/${id}`)
}
